/*eslint-disable*/
import React, { useEffect, useState } from "react";
import {
  Card,
  Button,
  Row,
  Col,
  CardBody,
  CardHeader,
  CardFooter,
  FormGroup,
  Label,
  Input,
  Container,
} from "reactstrap";

import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import SimpleHeader from "components/Headers/SimpleHeader.js";
import SweetAlert from "react-bootstrap-sweetalert";
import Select2 from "react-select2-wrapper";

export default function UpdateTanggalSurvey(props) {
  const token = localStorage.token;
  const username = localStorage.username;
  const history = useHistory();
  const [surveyor, setSurveyor] = useState("");
  const [surveyors, setSurveyors] = useState([]);
  const [tglsurvey, setTglSurvey] = useState("");
  const [waktusurvey, setWaktuSurvey] = useState("");
  const [alert, setAlert] = React.useState(null);

  useEffect(() => {
    
    getEngginer()
  }, [])
  

  const getEngginer = () => {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
    axios
      .get(
        `${process.env.REACT_APP_API_BASE_URL}/karyawan/list`,
        { headers }
      )
      .then((data) => {
        setSurveyors(data.data.response);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const updateKurir = () => {
    const headers = {
			"Content-Type": "application/json",
			Authorization: `Bearer ${token}`,
		};

    const data = {
        surveyor : surveyor,
        tgl_survey : tglsurvey,
        wkt_survey: waktusurvey,
    }
    
    axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/order-aplikator/update-tanggal-survey/${props.match.params.id}`, data, { headers })
      .then(function (response) {
        setSuccessAlert(response.data.message);
        setTimeout(() => (history.push("/admin/pemesanan/so/aplikator")), 1000);
      })
      .catch(function (error) {
          setGagalAlert(error.response.data.message);
      });
  };
  const setSuccessAlert = (id) => {
    setAlert(
      <SweetAlert
        success
        showConfirm
        confirmBtnText="Ok"
        title={id}
        onCancel={hideAlert}
        onConfirm={hideAlert}
      />
    )
  }

  const setGagalAlert = (id) => {
    setAlert(
      <SweetAlert
        danger
        showConfirm
        confirmBtnText="Ok"
        title={id}
        onCancel={hideAlert}
        onConfirm={hideAlert}
      />
    );
  };

  const setQuestionAlert = () => {
    setAlert(
      <SweetAlert
        warning
        showCancel
        confirmBtnText="Lanjutkan"
        confirmBtnBsStyle="danger"
        title="Apakah Kamu Yakin?"
        onConfirm={updateKurir}
        onCancel={hideAlert}
        focusCancelBtn
      />
    );
  };

  const hideAlert = () => {
    setAlert(null);
  }


  return (
    <div>
      {alert}
      <SimpleHeader name="Tanggal Survey" parentName="Master" />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <CardBody>
              <Card className="bg-secondary shadow">
                  <CardHeader className="bg-white border-0">
                    <h3>Tanggal Survey</h3>
                  </CardHeader>
                  <CardBody>
                    <Row md="12">
                      <Col md="6">
                      <FormGroup row>
                          <Label
                          className="form-control-label"
                            for="exampleEmail"
                            sm={4}
                          >
                            Surveyor
                          </Label>
                          <Col sm={7}>
                            <Select2
                                  className="form-control-alternative"
                                  defaultValue="0"
                                  value={surveyor}
                                  onChange={(e) => {
                                    setSurveyor(e.target.value);
                                  }}
                                  options={{
                                    placeholder: "Pilih Surveyor"
                                  }}
                                  data={surveyors.map((customer) => {
                                    return (
                                    { id: customer.username, text: customer.username}
                                    );
                                  })}
                                />
                          </Col>
                        </FormGroup>
                        <FormGroup row>
                          <Label
                          className="form-control-label"
                            for="exampleEmail"
                            sm={4}
                          >
                            Tanggal Survey
                          </Label>
                          <Col sm={7}>
                            <Input
                              autoComplete="off"
                              className="form-control-alternative"
                              type="date"
                              name="Nama"
                              placeholder="Masukan Nama"
                              value={tglsurvey}
                              onChange={(e) => {
                                setTglSurvey(e.target.value);
                              }}
                            />
                          </Col>
                        </FormGroup>
                        <FormGroup row>
                          <Label
                          className="form-control-label"
                            for="exampleEmail"
                            sm={4}
                          >
                            Waktu Survey
                          </Label>
                          <Col sm={7}>
                            <Input
                              autoComplete="off"
                              className="form-control-alternative"
                              type="time"
                              placeholder="Masukan Nama"
                              value={waktusurvey}
                              onChange={(e) => {
                                setWaktuSurvey(e.target.value);
                              }}
                            />
                          </Col>
                        </FormGroup>
                        {/* <FormGroup row>
                          <Label
                          className="form-control-label"
                            for="exampleEmail"
                            sm={4}
                          >
                            Per KG
                          </Label>
                          <Col sm={7}>
                            <CurrencyInput
                                
                                id="validation-example-2-field"
                                placeholder="Rp0"
                                allowDecimals={false}
                                value={perkg}
                                onValueChange={priceperkg}
                                className={`form-control`}
                                prefix={'Rp'}
                                step={10}
                            />
                          </Col>
                        </FormGroup>
                        <FormGroup row>
                          <Label
                          className="form-control-label"
                            for="exampleEmail"
                            sm={4}
                          >
                            Per KM
                          </Label>
                          <Col sm={7}>
                          <CurrencyInput
                                
                                id="validation-example-2-field"
                                placeholder="Rp0"
                                allowDecimals={false}
                                value={perkm}
                                onValueChange={priceperkm}
                                className={`form-control`}
                                prefix={'Rp'}
                                step={10}
                            />
                          </Col>
                        </FormGroup>
                        <FormGroup row>
                          <Label
                          className="form-control-label"
                            for="exampleEmail"
                            sm={4}
                          >
                            Packing Cairan
                          </Label>
                          <Col sm={7}>
                          <CurrencyInput
                                
                                id="validation-example-2-field"
                                placeholder="Rp0"
                                allowDecimals={false}
                                value={packingcairan}
                                onValueChange={pricepackingcairan}
                                className={`form-control`}
                                prefix={'Rp'}
                                step={10}
                            />
                          </Col>
                        </FormGroup>
                        <FormGroup row>
                          <Label
                          className="form-control-label"
                            for="exampleEmail"
                            sm={4}
                          >
                            Packing Pecah
                          </Label>
                          <Col sm={7}>
                          <CurrencyInput
                                
                                id="validation-example-2-field"
                                placeholder="Rp0"
                                allowDecimals={false}
                                value={packingpecah}
                                onValueChange={pricepackingpecah}
                                className={`form-control`}
                                prefix={'Rp'}
                                step={10}
                            />
                          </Col>
                        </FormGroup>
                        <FormGroup row>
                          <Label
                          className="form-control-label"
                            for="exampleEmail"
                            sm={4}
                          >
                            Status
                          </Label>
                          <Col sm={7}>
                            <Input
                              autoComplete="off"
                              className="form-control-alternative"
                              type="select"
                              name="Alamat"
                              placeholder="Masukan Alamat"
                              value={status}
                              onChange={(e) => {
                                setStatus(e.target.value);
                              }}
                            >
                                <option value="">Pilih Status</option>
                                <option value={1}>Aktif</option>
                                <option value={2}>Tidak Aktif</option>
                            </Input>
                          </Col>
                        </FormGroup> */}
                      </Col>
                      <Col md="6">
                      
                      </Col>
                    </Row>
                  </CardBody>
                  <CardFooter>
                    <Link className="btn btn-info" to="/admin/pemesanan/so/aplikator">
                      Kembali
                    </Link>
                    <Button color="danger" onClick={setQuestionAlert}>
                      Simpan
                    </Button>
                  </CardFooter>
              </Card>
            </CardBody>
          </div>
        </Row>
      </Container>
    </div>

  );
};
